/**
 * Página /tenant/calendar/settings - Configurações de Calendários
 *
 * Mantida como rota de deep-link (ex.: notificações de compartilhamento
 * usam /tenant/calendar/settings?cal=...). O conteúdo é o mesmo do modal
 * aberto a partir do calendário (CalendarSettingsContent).
 *
 * RELEASE:
 *   2026-06-24 v1.1.0 - Reutiliza CalendarSettingsContent (mesmo conteúdo do modal)
 *   2026-06-24 v1.0.0 - Versão inicial (gestão central de calendários)
 */

import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Calendar as CalendarIcon } from 'lucide-react';
import { ModularLayout } from '@/components/layouts/ModularLayout';
import { Button } from '@/components/ui/button';
import { CalendarSettingsContent } from '@/components/calendar/CalendarSettingsContent';

export default function CalendarSettingsPage() {
  const navigate = useNavigate();

  return (
    <ModularLayout>
      <div className="p-4 lg:p-6 space-y-4 max-w-5xl mx-auto w-full">
        {/* Cabeçalho */}
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate('/tenant/calendar')}
            aria-label="Voltar ao calendário"
          >
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <div className="flex-1">
            <h1 className="text-xl font-semibold flex items-center gap-2">
              <CalendarIcon className="h-5 w-5 text-primary" />
              Configurações de Calendários
            </h1>
            <p className="text-sm text-muted-foreground">
              Gerencie seus calendários, compartilhamentos e integrações Google.
            </p>
          </div>
        </div>

        <CalendarSettingsContent />
      </div>
    </ModularLayout>
  );
}
